exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-header[data-v-5e82b04c] {\n  padding: 0;\n  margin-bottom: 15px;\n}\n.page-header[data-v-5e82b04c] .ant-page-header-heading-title {\n  font-size: 14px;\n}\n.page-header .header-title[data-v-5e82b04c] {\n  color: #297ede;\n  cursor: pointer;\n}\n.action-detail[data-v-5e82b04c] {\n  min-width: 100px !important;\n  color: #0077fa !important;\n  cursor: pointer !important;\n}\n", ""]);

// exports
